import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c6768d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "article"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "base c-thirdary" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "space" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "icon i-aixin1"
}
const _hoisted_6 = {
  key: 1,
  class: "icon i-aixin"
}
const _hoisted_7 = { class: "html" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "toolbar c-thirdary" }
const _hoisted_10 = {
  key: 0,
  class: "comments"
}
const _hoisted_11 = { class: "c-tip" }
const _hoisted_12 = { class: "c-item" }
const _hoisted_13 = { class: "c-time c-thirdary" }
const _hoisted_14 = {
  key: 0,
  class: "r-top"
}
const _hoisted_15 = { class: "c-content" }
const _hoisted_16 = {
  key: 0,
  class: "reply"
}
const _hoisted_17 = { class: "reply-time c-thirdary" }
const _hoisted_18 = { class: "reply-content" }
const _hoisted_19 = {
  key: 0,
  class: "c-none"
}
const _hoisted_20 = {
  key: 1,
  class: "not-found"
}

import api from '@/api/articleApi';
import userApi from '@/api/userApi'
import { showCommentWriter } from '@/store/index'
import * as filters from '@/views/filters';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import Fymusic from './Fymusic.vue';
import Fyvideo from './Fyvideo.vue';
import user from '@/store/user';
import i18, { State as I18State } from '@/store/i18';
import devices from '@/store/device';


export default /*#__PURE__*/_defineComponent({
  props: {
    article: null,
    channelMode: null
  },
  setup(__props: any) {

const props = __props as {
    article?: Article,
    channelMode?: Boolean
}



const state = reactive({
    isSsr: true,
    writeText: '',
    writeVisible: false,
    isFav: false,
})
onMounted(() => {
    state.isSsr = false
    if (props.article) {
        loadComments()
        loadFav()
    }
})
watch(() => props.article, () => {
    if (props.article) {
        loadComments()
        loadFav()
    }
})
const store = useStore()
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].article)
const comments = ref<any[]>([])

const HtmlContent = computed(() => {
    let template = ''
    if (props.article) {
        template = text(props.article.content)
    } else {
        template = '<div></div>'
    }
    return {
        components: { Fymusic, Fyvideo },
        template
    }
})

function text(value: string) {
    if (value) {
        value = value.replace(/&lt;/g, '')
        value = value.replace(/&gt;/g, '')
        value = value.replace(/&amp;/g, '&')
        value = value.replace(/&nbsp;/g, ' ')
        value = value.replace(/src=""/g, '')
        value = value.replace(/data-original/g, 'src')
        value = value.replace(/ 0px=""/g, '')
        value = value.replace(/ 0rem=""/g, '')
        value = value.replace(/ -webkit-font-smoothing:=""/g, '')
        value = value.replace(/"https:\/\/yd.sanmanuela.com\/\?#\/article\/(\d+)"/g, '"/articles/$1/index.html"')

        value = value.replace(/https:\/\/mmbiz.qpic.cn\//g, '//img-tv.sanmanuela.com/wx/')
        value = value.replace(/<a .+? data-miniprogram-path.+?>/g, '<a>')
    }
    return value
}

async function onGood() {
    if (props.article) {
        await api.postGood(props.article.itemid)
        props.article.zans++
    }
}

function onShowCommentWrite() {
    if (props.article) {
        showCommentWriter(store, async (content: string) => {
            await api.postComment(props.article.itemid, content)
            comments.value.push({ nickname: '用户', content: content, addtime: Math.floor(Date.now() / 1000) })
        })
    }
}

async function loadComments() {
    comments.value = await api.getComments(props.article.itemid)
}

async function loadFav() {
    if (user.online(store, false)) {
        if (props.article) {
            state.isFav = await userApi.isCollect(props.article.itemid)
        }
    }
}

async function onFav() {
    if (user.online(store)) {
        if (props.article) {
            if (state.isFav) {
                await userApi.removeCollect(props.article.itemid)
                state.isFav = false
            } else {
                await userApi.addCollect(props.article.itemid)
                state.isFav = true
            }
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (__props.article)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.article.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(__props.article.author), 1),
          _createElementVNode("span", null, _toDisplayString(__props.article.passport), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(filters).date(__props.article.addtime)), 1),
          _hoisted_4,
          _createElementVNode("a", {
            onClick: onFav,
            class: _normalizeClass({ red: _unref(state).isFav })
          }, [
            (_unref(state).isFav)
              ? (_openBlock(), _createElementBlock("i", _hoisted_5))
              : (_openBlock(), _createElementBlock("i", _hoisted_6)),
            _createTextVNode(" " + _toDisplayString(_unref(lang).favorite), 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_unref(state).isSsr)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: __props.article.content
              }, null, 8, _hoisted_8))
            : (_openBlock(), _createBlock(_unref(HtmlContent), { key: 1 }))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_unref(lang).read) + " " + _toDisplayString(__props.article.hits), 1),
          (!__props.channelMode)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:;",
                onClick: onGood
              }, _toDisplayString(_unref(lang).good) + " " + _toDisplayString(__props.article.zans), 1))
            : _createCommentVNode("", true)
        ]),
        (!__props.channelMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString(_unref(lang).comments), 1),
                _createElementVNode("a", { onClick: onShowCommentWrite }, _toDisplayString(_unref(lang).addComment), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (item.istop)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(lang).top), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(item.nickname || _unref(lang).guest), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(filters).datetime(item.addtime)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.content), 1),
                  (item.reply)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", null, _toDisplayString(item.replyer), 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(filters).datetime(item.replytime)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(item.reply), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 256)),
              (comments.value.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(lang).noComments), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(lang).notfound), 1))
}
}

})